import {Injectable} from '@angular/core';
import {Cpe} from '../../view/manifestos/cpe/model/Cpe';
import {URL_API} from '../../tools/URL';
import {catchError} from 'rxjs/operators';
import {ErrorsService, SALVAR} from '../errors/errors.service';
import {RestService} from '../rest.service';

@Injectable({
  providedIn: 'root'
})
export class CpeService {

  constructor(
    private rest: RestService,
    private errorsService: ErrorsService) {
  }

  salvar(registro: Cpe, enviar: boolean = true) {
    if(enviar){
      return this.rest.post(`${URL_API.PATH_CPE}/enviar`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }else{
      return this.rest.post(`${URL_API.PATH_CPE}/salvar`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }
  }

  atualizar(registro: Cpe, id: number, enviar: boolean = true) {
    if(enviar){
      return this.rest.put(`${URL_API.PATH_CPE}/enviar/${id}`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }else{
      return this.rest.put(`${URL_API.PATH_CPE}/salvar/${id}`, registro).pipe(
        catchError(response => this.errorsService.handleError(response, SALVAR))
      );
    }
  }
  carregarPorId(id: number) {
    return this.rest.get(`${URL_API.PATH_CPE + '/' + id}`);
  }

}

